/**
 * Empty state for tasks - shows "+ Add Task" button to create first task
 * Story 227: Edit PRDs, tech designs and tasks
 */

import { useCallback } from 'react';
import { useTaskMutations } from '../../hooks/useTaskMutations';
import './EmptyDocState.css';

interface EmptyTaskStateProps {
  projectSlug: string;
  storyId: string;
}

export function EmptyTaskState({ projectSlug, storyId }: EmptyTaskStateProps) {
  const { createTask } = useTaskMutations(projectSlug, storyId);

  const handleAdd = useCallback(() => {
    createTask.mutate({
      title: 'New task',
      body: '',
    });
  }, [createTask]);

  return (
    <button
      className="empty-doc-state"
      onClick={handleAdd}
      disabled={createTask.isPending}
      type="button"
    >
      <svg viewBox="0 0 16 16" fill="currentColor" width="16" height="16">
        <path d="M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2z" />
      </svg>
      {createTask.isPending ? 'Adding...' : 'Add Task'}
    </button>
  );
}
